import { render } from "./MailLogin.vue?vue&type=template&id=5ffa770a"
import script from "./MailLogin.vue?vue&type=script&lang=js"
export * from "./MailLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__